import Spinner from 'styled-up/dist/Spinner';

Spinner.defaultProps.duration = 0.8;

export default Spinner;
